import React from 'react';
import Box from '@mui/material/Box';
import clsx from 'clsx';
import { IDeveloperWithSharedComplexes } from 'src/typings/usersManage';
import { Option } from 'src/typings/app';
import { useStyles } from './styles';

interface IDeveloperProps {
  isSelected: (value: string) => boolean;
  isChanged: (value: IDeveloperWithSharedComplexes) => boolean;
  developer: IDeveloperWithSharedComplexes;
  selectedProjectsCount: number;
  onClick?: (e: Option<string>) => void;
}
export const Developer: React.FC<IDeveloperProps> = ({
  isSelected, isChanged, developer, selectedProjectsCount, onClick,
}) => {
  const styles = useStyles();
  const _onClick = () => {
    if (onClick) {
      onClick({ label: developer.name, value: developer['@id'] });
    }
  };
  return (
    <Box
      className={`${styles.developer} ${clsx(
        isSelected(developer['@id']) && 'selected',
        isChanged(developer) && 'changed',
      )}`}
      onClick={_onClick}
    >
      <div className="title">{`${developer.name}`}</div>
      <div className="count">{`${selectedProjectsCount > 0 ? `(${selectedProjectsCount})` : ''}`}</div>
    </Box>
  );
};
